import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 24,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 3,
    color: theme.switchBase.main,
    '&$checked': {
      transform: 'translateX(19px)',
      color: theme.switchBase.checked,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.switchBase.selectTrack,
        borderColor: theme.switchBase.selectTrack,
      },
    },
  },
  thumb: {
    width: 17,
    height: 17,
    marginLeft: 1,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.switchBase.main}`,
    borderRadius: 50,
    opacity: 1,
    backgroundColor: theme.switchBase.track,
  },
  checked: {},
}))(Switch);

const SwitchiOSPurchase = ({
  check, handleChange, lblOff, lblOn, ...other
}) => (
  <FormGroup>
    <Typography component="div">
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item>{lblOff}</Grid>
        <Grid item>
          <AntSwitch onChange={handleChange} name="checkedC" {...other} />
        </Grid>
        <Grid item>{lblOn}</Grid>
      </Grid>
    </Typography>
  </FormGroup>
);
export default SwitchiOSPurchase;
